<template>
  <div class="general-information interview-general-container">
    <div class="rectangle">
      <b-row class="mb-0">
        <b-col>
          <div class="col-12 m-0 p-0 mb-4">
            <h3 class="general-information__title">
              {{
                isQuestionPage
                ? resource['questionGenerator.interviewInformationLabel']
                : resource['hrvenue.interviewInformationLabel']
              }}
            </h3>
          </div>
          <validation-observer v-slot="{ validate }" class="title-area">
            <validate-form
              id="nameField"
              v-model="interview.name"
              type="text"
              rules="required|min:5"
              class="form-control-name"
              @keypress="maxLengthCheck($event, 50, 'name')"
              @keyup="maxLengthCheck($event, 50, 'name')"
              @input="checkValidate(validate)"
              :name="resource['hrvenue.interviewInformationTitle']"
              :placeholder="resource['hrvenue.interviewInformationTitlePlaceholder']"
            >
              <div slot="customLabel" class="mb-2">
                <h3>
                  {{
                    isQuestionPage
                    ? resource['questionGenerator.interviewInformationTitle']
                    : resource['hrvenue.interviewInformationTitle']
                  }} *
                </h3>
              </div>
            </validate-form>
          </validation-observer>
          <div class="ats-integration-area" v-if="!isQuestionPage">
            <h3>{{ resource['interviewDetail.AtsIntegrationTitle'] }}<span> {{ resource['interviewDetail.AtsIntegrationOptionalLabel'] }}</span></h3>
            <b-form-checkbox id="ats-integration-checkbox" v-model="interview.isAtsIntegrationsEnabled" class="checkbox-2 checkbox-ats" @change="deleteAtsIntegration">
              {{ resource['interviewDetail.AtsIntegrationCheckboxLabel'] }}
            </b-form-checkbox>
            <div class="ats-integration-area__divider" v-if="interview.isAtsIntegrationsEnabled"></div>
            <div class="d-flex align-items-center justify-content-between w-100" v-if="interview.isAtsIntegrationsEnabled">
              <unified-connections @createNewInterViewer="{}" :unifiedDataType="'job'" :interview="interview" :generateQuestionWithAiRight="generateQuestionWithAiRight"/>
            </div>
            <div class="ats-integration-area__info" v-if="interview.isAtsIntegrationsEnabled">
              <i class="icon-info" />
              <span>{{ resource['interviewDetail.AtsIntegrationInfoText'] }}  </span>
            </div>
          </div>
          <div class="set-language-area">
            <div class="language-selection">
              <div class="language-item">
                <validation-observer>
                  <!-- Question Language Dropdown -->
                  <validate-form
                    v-model="interview.questionLanguage"
                    which-component="multiselect"
                    id="questionLanguageList"
                    :name="languageConfig.language.labelText"
                    :label="languageConfig.language.label"
                    :options="languageConfig.language.options"
                    :loading="languageConfig.language.loading"
                    :track-by="languageConfig.language.trackBy"
                    :hide-selected="false"
                    :searchable="true"
                    :allow-empty="false"
                    :placeholder="resource['interviewDetail.SetQuestionLanguageListPlaceholder']"
                    openDirection="bottom">
                    <div slot="customLabel" class="mb-2 custom-label">
                      <h3>
                        {{ resource["interviewDetail.SetQuestionLanguageListTitle"] }}
                        <i class="icon-info" id="question-language-info"></i>
                      </h3>
                    </div>
                  </validate-form>
                </validation-observer>
                <b-tooltip
                  target="question-language-info"
                  triggers="hover"
                  placement="bottom"
                  custom-class="big-tooltip-inner feature-tooltip-general-information"
                  :delay="{ show: 150, hide: 200 }"
                >
                  {{ resource["interviewDetail.SetQuestionLanguageInfoText"] }}
                </b-tooltip>
              </div>
              <div class="language-item" v-if="interview.type === 1">
                <validation-observer>
                  <!-- Email Language Dropdown -->
                  <validate-form
                    v-model="interview.emailLanguage"
                    which-component="multiselect"
                    id="emailLanguageList"
                    :name="languageConfig.language.labelText"
                    :label="languageConfig.language.label"
                    :options="languageConfig.language.options"
                    :loading="languageConfig.language.loading"
                    :track-by="languageConfig.language.trackBy"
                    :hide-selected="false"
                    :searchable="true"
                    :placeholder="resource['interviewDetail.SetEmailLanguageListPlaceholder']"
                    openDirection="bottom">
                    <div slot="customLabel" class="mb-2 custom-label">
                      <h3>
                        {{ resource["interviewDetail.SetEmailLanguageListTitle"] }}
                        <i class="icon-info" id="email-language-info"></i>
                      </h3>
                    </div>
                  </validate-form>
                </validation-observer>
                <b-tooltip
                  target="email-language-info"
                  triggers="hover"
                  placement="bottomleft"
                  custom-class="big-tooltip-inner feature-tooltip-general-information"
                  :delay="{ show: 150, hide: 200 }"
                >
                  {{ resource["interviewDetail.SetEmailLanguageInfoText"] }}
                </b-tooltip>
              </div>
            </div>
          </div>
          <div class="visible-area" v-if="!isEdit || (isEdit && interview.changeVisibilityTypeAuthorized)">
            <validation-observer v-slot="{ validate }">
              <validate-form id="visibility" v-model="interview.visibilityType" rules="required"
                which-component="b-form-radio-group" name="Visibility" @input="checkValidateUser(validate)">
                <div slot="customLabel" class="mb-2 custom-label">
                  <h3 class="bold">
                    {{ resource["interviewDetail.VisibilityTitle"] }}
                  </h3>
                </div>
                <b-form-radio :value="2" class="checkbox-1 mr-2 custom-checked-box">
                  {{ resource["interviewDetail.VisibilityJustMe"] }}
                </b-form-radio>
                <b-form-radio :value="1" class="checkbox-1 mr-2 custom-checked-box">
                  {{ resource["interviewDetail.VisibilityEveryone"] }}
                </b-form-radio>
                <b-form-radio :value="3" class="checkbox-1 mr-2 custom-checked-box">
                  {{ resource["interviewDetail.VisibilitySpecial"] }}
                </b-form-radio>
              </validate-form>
            </validation-observer>
            <validation-observer v-slot="{ validate }" class="userlist-content">
              <validate-form
                v-if="interview.visibilityType === 3"
                v-model="interview.authorizedUsers"
                which-component="multiselect"
                id="userList"
                :rules="interview.visibilityType === 3 ? 'required' : ''"
                :multiple="true"
                :close-on-select="false"
                :name="resource['interviewDetail.UserListName']"
                :label="userConfig.user.label"
                :placeholder="resource['interviewDetail.UserListPlaceholder']"
                :options="userConfig.user.options"
                :loading="userConfig.user.loading"
                :track-by="userConfig.user.trackBy"
                :hide-selected="true"
                @input="checkValidateUser(validate)"
                @remove="checkValidateUser(validate)">
                <div slot="customLabel" class="mb-2 custom-label">
                  <h3 class="bold">
                    {{ resource["interviewDetail.VisibilityUserListTitle"] }}
                  </h3>
                </div>
                <span slot="noResult">{{ resource["label.NoResult"] }}</span>
              </validate-form>
            </validation-observer>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { convertObjectKeyValueNamesUser } from '@/static/helpers/';
import { languageItems } from '@/static/languageItems';
import hrvenueService from '../../../services/hrvenue.service';
import UnifiedConnections from '../../unified/UnifiedConnections.vue';
import ResourceManager from '../../../services/resource.service';

export default {
  name: 'GeneralInformation',

  components: {
    UnifiedConnections,
  },

  props: {
    interview: {
      type: Object,
      required: true,
    },
    deletedQuestionAI: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      page: 0,
      titleLength: 0,
      firstValue: '',
      showNoResult: false,
      searchText: '',
      hasNextPage: true,
      userConfig: {
        user: {
          labelHelpText: 'User',
          name: 'userList',
          label: 'displayName',
          trackBy: 'value',
          options: [],
          loading: false,
          displayedOptionsLimit: 300,
          visibleResultLimit: 10,
          minCharLimit: 3,
          labelText: 'UserList',
        },
      },
      languageConfig: {
        language: {
          labelText: 'LanguageList',
          label: 'title',
          trackBy: 'id',
          options: languageItems,
          loading: false,
        },
      },
      pageType: '',
    };
  },

  computed: {
    isQuestionPage() {
      return this.pageType === 'question';
    },
    isEdit() {
      return !!this.$route.params.interviewId;
    },
  },

  async created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
    this.deletedQuestionAI.length = 0;

    this.setDefaultLanguageSelections();
  },

  mounted() {
    this.setUserList();
  },

  methods: {
    deleteAtsIntegration() {
      if (!this.interview.isAtsIntegrationsEnabled) {
        this.interview.selectedConnection = null;
        this.interview.selectedJob = null;
      }
    },
    checkValidate(validate) {
      if (this.interview?.name !== this.firstValue && this.interview?.name?.length >= 5) {
        validate();
        this.titleLength = this.interview.name.length;
      }
      if (this.interview.name.length < this.titleLength) {
        validate();
      }
    },
    checkValidateUser(validate) {
      validate();
    },
    setWhichInput(InpEl, value) {
      this.interview.name = value;
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
    async setUserList() {
      this.userConfig.user.loading = true;
      const response = await hrvenueService.getUsers();
      this.userConfig.user.loading = false;
      if (response.list) {
        this.userConfig.user.options = convertObjectKeyValueNamesUser(
          response,
          'list',
          'id',
          'name',
          'surname',
          this.userConfig.user.trackBy,
          this.userConfig.user.label,
        );
      }
    },

    getCurrentLanguageFromHeader() {
    // SideBarHeader'dan mevcut dil bilgisini al
      let currentLanguage = null;

      if (typeof ResourceManager.CurrentLang !== 'string') {
        currentLanguage = ResourceManager.CurrentLang;
      } else {
      // String ise, languageItems'dan bul
        currentLanguage = this.languageConfig.language.options.find(
          (item) => item.code === ResourceManager.CurrentLang,
        );
      }

      return currentLanguage;
    },

    setDefaultLanguageSelections() {
      const currentLang = this.getCurrentLanguageFromHeader();

      if (currentLang) {
      // Hem question hem email language için aynı dili set et
        if (!this.interview.questionLanguage) {
          this.interview.questionLanguage = currentLang;
        }

        if (!this.interview.emailLanguage) {
          this.interview.emailLanguage = currentLang;
        }
      }
    },
  },
  watch: {
    interview: {
      handler(newVal) {
        this.firstValue = newVal?.name;
        this.titleLength = newVal?.name?.length;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@import "~@/style/starter.scss";
.general-information {
  &__title {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }
}

#job_create_qualifications {
  .trumbowyg-box {
    &:focus-within {
      -webkit-box-shadow: 0 0 5px 2px rgb(216, 216, 216);
      box-shadow: 0 0 5px 2px rgb(216, 216, 216);
      border-radius: 4px;
    }
  }

  .trumbowyg-disabled {
    .trumbowyg-editor {
      background-color: #e9ecef;
      opacity: 1;
    }
  }
  .fw-500 {
    font-weight: 500 !important;
  }

  .trumbowyg-editor {
    max-height: 250px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background-color: #e6e6e6;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #b1afaf;
    }
  }

  & .trumbowyg-editor {
    & ul {
      padding: 5px 0px 5px 20px;
    }

    & p {
      padding-bottom: 10px;
    }

    & a {
      color: #4285f4 !important;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .trumbowyg-button-pane {
    display: inherit;
  }
}
#remoteWorkType {
  label {
    &:before {
      font-weight: bold;
    }
  }
}

.form-control-name {
  input {
    &:focus {
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30) !important;
      outline: 1px solid #FF8D06 !important;
      border-color: #FF8D06 !important;
    }
  }

}

.visible-area {
  border-radius: 4px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  background: #FAFAFA;
  margin: 16px 0 0;

  .userlist-content {
    width: 100%;
  }

  .custom-label {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      color: #333;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }
  }

  .multiselect__tags {
    padding-left: 8px !important;
    padding-bottom: 6px !important;
    flex-direction: column;
    align-items: flex-start;
  }

  .multiselect--above .multiselect__content-wrapper {
    bottom: unset;
  }

  .multiselect__tag-icon {
    background: #858585;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0;
    top: 5px;
    right: 4px;

    &::after {
      color: #E5E5E5;
      font-size: 1.2em;
    }
  }

  .custom-radio {
    label {
      font-family: Roboto;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
.big-tooltip-inner {
  .tooltip-inner{
    width: fit-content !important;
    max-width: 300px !important;
  }
}
.small-tooltip-inner {
  .tooltip-inner{
    width: 208px !important;
  }
}

.feature-tooltip-general-information {
  opacity: 1 !important;

  &.bs-tooltip-right {
   .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>') !important;
        width: 9px;
        height: 17px;
      }
    }
  }

  &.bs-tooltip-left {
   .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>') !important;
        width: 9px;
        height: 17px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 15px !important;

    .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>') !important;
        width: 9px;
        height: 17px;
        transform: rotate(90deg);
        bottom: 2px;
      }
    }
  }

  .tooltip-inner {
    background: #FFF !important;
    border-radius: 4px !important;
    padding: 12px !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);

    text-align: left;
    color: #333;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}

.interview-general-container {
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-bottom: 50px;
    margin-top: 32px;
  }
}

.checkbox-ats {
  label {
    padding-left: 4px !important;
  }
  .custom-control-input {
    &:checked {
      & ~ .custom-control-label {
        &::before {
          content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
          color: $white !important;
          background: $purple !important;
          font-size: 14px;
          text-align: center;
          position: absolute;
          left: -22px;
        }
      }
    }
  }

  .custom-control-label {
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
    display: flex;
    align-items: center;
    color: #333333;
  }
}

.title-area {
  display: block;
  padding: 16px;
  border-radius: 4px;
  background: #FAFAFA;
  margin: 16px 0;

  h3 {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
}

.ats-integration-area {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  background: #FAFAFA;
  margin: 16px 0;

  h3 {
    color: #333;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    span {
      color: #878787;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  &__divider {
    display: flex;
    background: #E5E5E5;
    width: 100%;
    height: 1px;
    padding-top: 1px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
  }

  .unified-connections {
    width: 100%;
    padding: 0;
  }

  &__info {
    display: flex;
    gap: 2px;
    align-items: center;

    span, i {
      color: var(--Text-Colors-Secondary-Gray-Text, #878787);
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      margin-top: 0 !important;
    }
  }
}
.set-language-area {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  background: #FAFAFA;
  margin: 16px 0;

  .multiselect--active {
    .multiselect__tags {
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30) !important;
      outline: 1px solid #FF8D06 !important;
      border-radius: 4px;
    }
  }

  .multiselect__tags {
    padding-left: 8px !important;
  }

  .multiselect__content-wrapper {
    max-height: 500px !important;
  }

  .multiselect__option--highlight {
    background: #EEE;
  }

  .multiselect__option--selected:after {
    display: none;
  }

  .multiselect__select:before {
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.25488 9.51094L9.41321 11.6693C9.73821 11.9943 10.2632 11.9943 10.5882 11.6693L12.7465 9.51094C13.2715 8.98594 12.8965 8.08594 12.1549 8.08594H7.83821C7.09654 8.08594 6.72988 8.98594 7.25488 9.51094Z" fill="%23333333"/></svg>') !important;
    border: none !important;
    top: 20% !important;
  }

  .multiselect__content-wrapper {
    z-index: 999;
    top: 48px !important;
    padding: 4px 0;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  }

  .multiselect__content {
    box-shadow: none !important;
  }

  .language-selection {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      flex-direction: column;
    }

    .language-item {
      flex: 1;

      .custom-label {
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          font-size: 16px;
        }

        h3 {
          color: #333;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: Roboto;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
